export const errorCodes = {
  '400001': 'i18n_code_400001', // 欄位參數錯誤
  '400003': 'i18n_code_400003', // 認證參數缺失或格式錯誤
  '401001': 'i18n_code_401001', // Token 過期
  '403001': 'i18n_code_403001', // 帳號被停用
  '403002': 'i18n_code_403002', // 帳號被停用
  '403003': 'i18n_code_403003', // 不允許訪問
  '403004': 'i18n_code_403004', // OTP失效
  '403015': 'i18n_code_403015', // IP 不允許訪問
  '500001': 'i18n_code_500001', // 伺服器異常
  '409001': 'i18n_code_409001', // 帳號已存在
  '401002': 'i18n_code_401002', // 帳號或密碼不正確
  '404012': 'i18n_code_404012' // 此項目組目前無法建單，請重選項目組
}

/**
 * 編號前綴 ID
 * USER: XU
 */
export const PrefixID = {
  USER: 'XU'
}

/**
 * 狀態
 * 1: 啟用
 * 2: 停用
 */
export const STATUS = {
  ENABLE: 1,
  DISABLE: 2
}

/**
 * 多地址選項
 * 2: 多地址
 * 1: 單一地址
 * 0: 全部
 */
export const AddrMode = {
  ALL: 0,
  SINGLE: 1,
  MULTIPLE: 2
}
export const AddrModeMap = [
  {
    key: 'ALL',
    value: AddrMode.ALL,
    name: 'i18n_all'
  },
  {
    key: 'MULTIPLE',
    value: AddrMode.MULTIPLE,
    name: 'i18n_multiple_rec_address'
  },
  {
    key: 'SINGLE',
    value: AddrMode.SINGLE,
    name: 'i18n_single_rec_address'
  }
]

/**
 * 客服建單方式
 */
export const CustomerExchangeType = {
  ALL: 0,
  COIN: 1,
  DOLLAR: 2
}
export const CustomerExchangeTypeMap = [
  {
    key: 'ALL',
    value: CustomerExchangeType.ALL,
    name: 'i18n_all'
  },
  {
    key: 'COIN',
    value: CustomerExchangeType.COIN,
    name: 'i18n_enter_coin'
  },
  {
    key: 'DOLLAR',
    value: CustomerExchangeType.DOLLAR,
    name: 'i18n_enter_dollar'
  }
]

/**
 * 訂單狀態
 * 0: 全部
 * 1: 處理中
 * 2: 交易成功
 * 3: 交易失敗
 * 4: 待確認
 * 5: 交易取消
 */

export const orderStatusMap = [
  {
    key: '0',
    value: 'ALL',
    name: 'i18n_all'
  },
  {
    key: '1',
    value: 'PROCESSING',
    name: 'i18n_order_pending',
    color: 'orange'
  },
  {
    key: '2',
    value: 'SUCCESS',
    name: 'i18n_order_success',
    color: 'green'
  },
  {
    key: '3',
    value: 'FAILED',
    name: 'i18n_order_fail',
    color: 'red'
  },
  {
    key: '5',
    value: 'CANCELED',
    name: 'i18n_order_canceled',
    color: 'red'
  }
]

/**
 * 角色 ID
 * 1: 客服員
 * 2: 訂單確認員
 * 3: 訂單查閱員
 * 4: 提現員
 * 5: 業務組
 * 6: 查收員
 * 7: 審計員
 * 8: 管理員
 * 9: 分口資料讀取員
 */
export const ROLEID = {
  CUSTOMER_SERVICE: 1,
  ORDER_CHECKER: 2,
  REPORT_VIEWER: 3,
  CASHIER: 4,
  BUSINESS_GROUP: 5,
  CHECKER: 6,
  AUDITOR: 7,
  OPERATOR: 8,
  FENKO_DATA_VIEWER: 9
}

/**
 * 審計狀態
 * 1: 未審計
 * 2: 通過
 * 3: 手動通過
 * 4: 不通過
 */
export const auditOrderStatusMap = [
  { key: 0, name: 'i18n_all', color: '' },
  { key: 1, name: 'i18n_unaudit', color: 'orange' },
  { key: 2, name: 'i18n_pass', color: 'green' },
  { key: 3, name: 'i18n_manual_pass', color: 'cyan' },
  { key: 4, name: 'i18n_unpass', color: 'red' }
]

/**
 * 平台名稱
 * Operator: 財務平台
 * Fenko: 分口平台
 */
export const PLATFORM_NAME = {
  Operator: 'i18n_operator_platform',
  Fenko: 'i18n_department_platform'
}

/**
 * 實收比對狀態
 * UNKNOWN: 未定義
 * ALL: 全部
 * EQUAL: 相同
 * DIFFERENT: 有偏差
 * UNIMPORT: 未導入
 */
export const actualCoinsMatchStatusMap = [
  { key: 'UNKNOWN', name: '-', color: '' },
  { key: 'ALL', name: 'i18n_all', color: '' },
  { key: 'EQUAL', name: 'i18n_equal', color: 'green' },
  { key: 'DIFFERENT', name: 'i18n_different', color: 'red' },
  { key: 'UNIMPORT', name: 'i18n_unimport', color: 'orange' }
]

/**
 * 查收比對狀態
 * 0: 全部
 * 1: 相同
 * 2: 有偏差
 * 3: 未導入
 */
export const checkCoinsMatchStatusMap = [
  { key: 0, name: 'i18n_all', color: '' },
  { key: 1, name: 'i18n_equal', color: 'green' },
  { key: 2, name: 'i18n_different', color: 'red' },
  { key: 3, name: 'i18n_unimport', color: 'orange' }
]

export const NOTIFY_TYPE = {
  SYSTEM_ANNOUNCEMENT: 1,
  ADDRESS: 2
}
